import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './App.css';
import './Login.css';
import HomePage from './components/HomePage';

const apiUrl = process.env.REACT_APP_API_URL || 'https://vakra.co.in/api';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const normalizeVendorType = (value) => {
    const text = String(value || '').trim().toLowerCase();

    if (text === 'fastfood' || text === 'food' || text === 'fast_food') return 'fastfood';
    if (text === 'cosmetic' || text === 'cosmetics') return 'cosmetic';
    if (text === 'garment' || text === 'garments') return 'garments';
    if (text === 'grocery') return 'grocery';

    return text;
  };

  const normalizeGroceryMode = (value) => {
    const text = String(value || '').trim().toLowerCase();

    if (text === 'wholesale' || text === 'wholsale') return 'wholesale';
    if (text === 'retail') return 'retail';

    return '';
  };

  const pickValue = (...values) => {
    for (const value of values) {
      if (value !== undefined && value !== null && String(value).trim() !== '') {
        return String(value).trim();
      }
    }

    return '';
  };

  const saveLoginData = (data) => {
    const vendorType = normalizeVendorType(
      pickValue(
        data.vendorType,
        data.vendor_type,
        data.businessType,
        data.business_type,
        data.user?.vendorType,
        data.user?.vendor_type,
        data.user?.businessType,
        data.user?.business_type
      )
    );

    const groceryMode = normalizeGroceryMode(
      pickValue(
        data.groceryMode,
        data.grocery_mode,
        data.groceryModeType,
        data.grocery_mode_type,
        data.mode,
        data.user?.groceryMode,
        data.user?.grocery_mode,
        data.user?.mode
      )
    );

    const shopName = pickValue(
      data.shopName,
      data.shop_name,
      data.storeName,
      data.store_name,
      data.user?.shopName,
      data.user?.shop_name,
      data.user?.storeName,
      data.user?.store_name
    );

    const vendorName = pickValue(
      data.name,
      data.userName,
      data.user_name,
      data.vendorName,
      data.vendor_name,
      data.user?.name,
      data.user?.userName,
      data.user?.user_name
    );

    localStorage.setItem('token', data.token || '');

    localStorage.setItem('vendorType', vendorType);
    localStorage.setItem('vendor_type', vendorType);
    localStorage.setItem('businessType', vendorType);
    localStorage.setItem('business_type', vendorType);

    localStorage.setItem('groceryMode', groceryMode);
    localStorage.setItem('grocery_mode', groceryMode);
    localStorage.setItem('groceryModeType', groceryMode);
    localStorage.setItem('grocery_mode_type', groceryMode);
    localStorage.setItem('mode', groceryMode);

    localStorage.setItem('shopName', shopName);
    localStorage.setItem('shop_name', shopName);
    localStorage.setItem('storeName', shopName);
    localStorage.setItem('store_name', shopName);

    localStorage.setItem('vendorName', vendorName);
    localStorage.setItem('vendor_name', vendorName);
    localStorage.setItem('userName', vendorName);
    localStorage.setItem('user_name', vendorName);

    localStorage.setItem(
      'user',
      JSON.stringify({
        ...(data.user || {}),
        vendorType,
        vendor_type: vendorType,
        businessType: vendorType,
        business_type: vendorType,
        groceryMode,
        grocery_mode: groceryMode,
        groceryModeType: groceryMode,
        grocery_mode_type: groceryMode,
        mode: groceryMode,
        shopName,
        shop_name: shopName,
        storeName: shopName,
        store_name: shopName,
        name: vendorName,
      })
    );

    window.dispatchEvent(new Event('storage'));

    return {
      vendorType,
      groceryMode,
      shopName,
      vendorName,
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${apiUrl}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();
      console.log('API Response:', data);

      if (response.ok) {
        saveLoginData(data);

        alert('Login Successful');

        // ✅ Login ke baad hamesha OrdersReceived first page open hoga
        navigate('/ordersReceived', { replace: true });
      } else {
        alert(data.error || data.message || 'Login failed!');
      }
    } catch (error) {
      console.error('Login Error:', error);
      alert('Network error. Please try again!');
    }
  };

  return (
    <div className="login-wrapper">
      <HomePage />

      <div className="auth-container">
        <h2>Login</h2>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email:</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Password:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <p>
              <Link to="/ForgetPassword">Forgot password</Link>
            </p>
          </div>

          <button type="submit">Login</button>
        </form>

        <p>
          Don&apos;t have an account? <Link to="/signup">Signup here</Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
